import React from "react";
import SectionTitle from "../../../../../Shared/SectionTitle/SectionTitle";
import BoxServiceComponent from "./BoxServiceComponent";

import { WorkFieldData } from "../../../../../../api/workFieldData";

import "./Service.css";

const ServiceSection = (props) => {
  return (
    <div className={`wpo-service-area section-padding ${props.sClass}`}>
      <div className="container">
        <SectionTitle
          subTitle={"Découvrir"}
          MainTitle={"Les Industries que nous desservons"}
        />
        <div className="row align-items-center">
          <div className="boxes-services">
            {WorkFieldData.map((data) => (
              <BoxServiceComponent
                key={data.id}
                icon={data.icon}
                title={data.name}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
